import _ from 'lodash';

type TypeElement = {
  type: string;
  value?: string;
  children?: TypeElement[];
};

const returnValue = (x: TypeElement): string => x.value!;

const nestedMap = (array: TypeElement[]): string[] => {
  return array
    .map((item: TypeElement) => {
      if (item.type === 'element') {
        return nestedMap(item.children!);
      }

      return returnValue(item);
    })
    .flat();
};

export const formatTitleId = (array: TypeElement[]) => {
  return _.kebabCase(nestedMap(array).join(''));
};
